import React, { useMemo } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import RecibosVendedores from "../../InfoRecibos/RecibosVendedor";
import PedidosRecibos from "../../InfoRecibos/PedidosRecibos";
import RecibosEmpresa from "../../InfoRecibos/RecibosEmpresa";
import { useSelector } from "react-redux";
import { decryptData } from "../../../functions/cryptoUtils";
import Contrarreembolso from "../../InfoRecibos/Contrarrembolso";

const MisRecibos = () => {
  const encryptedUser = useSelector((store: any) => store.authreducer.user);
  const user = useMemo(() => decryptData(encryptedUser), [encryptedUser]);

  return (
    <div>
      {/* <!-- breadcrumb --> */}
      <div className="breadcrumb-header justify-content-between">
        <div className="left-content">
          <span className="main-content-title mg-b-0 mg-b-lg-1">
            Mis Recibos
          </span>
        </div>
        <div className="justify-content-center mt-2"></div>
      </div>
      <Row className="d-flex align-items-stretch mg-b-10">
        <Col xl={6} lg={6} md={6} sm={6}>
          <Card className="sales-card h-100">
            <Row>
              <div className="text-justified tx-14 align-items-center">
                <div className="ps-4 pt-4 pe-3 pb-4">
                  <h3 className="text-dark tx-14 font-weight-semibold mb-2 mt-0">
                    Servicio de notificaciones{" "}
                    <text className="text-primary">AUTOMATICAS</text>{" "}
                  </h3>
                  <p className="mb-0 tx-12 text-dark">
                    En Ferretera Central contamos con un sistema de notificacion
                    automatico que nos garantiza la transparencia y seguridad de
                    su dinero. Registrando su numero de whatsapp recibira una{" "}
                    <text className="text-primary">
                      notificacion instantanea
                    </text>{" "}
                    al momento de que un vendedor le realice un Recibo, el
                    transporte entregue un contrarembolso o abone por caja en
                    las oficinas. De esta manera usted tendra el seguimiento de
                    todo su dinero.<br></br> En caso de alguna anomalia en sus
                    movimientos por favor comunicarse con{" "}
                    <a
                          href={`https://wa.me/5493585754880?text=${encodeURIComponent(
                            `Buenos días, soy el cliente ${user.clienteCodigo} - ${user.clienteRazonSocial} y quisiera registrar mi número de teléfono para las notificaciones automáticas.`
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary font-weight-semibold"
                        >
                          +54 9 358 5754880
                        </a>
                  </p>
                </div>
              </div>
            </Row>
          </Card>
        </Col>
        {user?.whatsapp?.waId ? (
          <Col xl={6} lg={6} md={6} sm={6}>
            <Card className="sales-card h-100">
              <Row>
                <div className="col-10">
                  <div className="ps-4 pt-4 pe-3 pb-4">
                    <h6 className="mb-2 tx-12 text-muted">Número registrado</h6>
                    <h4 className="tx-20 font-weight-semibold mb-2">
                      {user.whatsapp.waId}
                    </h4>
                    <p className="mb-0 tx-12 text-muted">
                      ¿Este número de WhatsApp es correcto?
                      <br />
                      Si no lo es, por favor comunicate con nuestro equipo al{" "}
                      <span className="text-primary font-weight-semibold">
                        <a
                          href={`https://wa.me/5493585754880?text=${encodeURIComponent(
                            `Buenos días, soy el cliente ${user.clienteCodigo} - ${user.clienteRazonSocial} y quisiera registrar mi número de teléfono para las notificaciones automáticas.`
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary font-weight-semibold"
                        >
                          +54 9 358 5754880
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="col-2 d-flex align-items-center justify-content-center">
                  <div className="circle-icon bg-success-transparent text-center">
                    <i className="fe fe-check-circle tx-18 text-success"></i>
                  </div>
                </div>
              </Row>
            </Card>
          </Col>
        ) : (
          <Col xl={6} lg={6} md={6} sm={6}>
            <Card className="sales-card h-100">
              <Row>
                <div className="col-10">
                  <div className="ps-4 pt-4 pe-3 pb-4">
                    <h3 className="text-dark tx-14 font-weight-semibold mb-2 mt-0">
                      <text className="text-primary">Registrate</text>{" "}
                    </h3>
                    <p className="mb-3 tx-12 text-dark">
                      Conoce los movimientos de tu dinero. Para poder recibir
                      las notificaciones de whatsapp por cada movimiento de
                      dinero, tenes que solicitarlo al numero de atencion
                      comercial{" "}
                      <a
                        href={`https://wa.me/5493585754880?text=${encodeURIComponent(
                          `Buenos días, soy el cliente ${user.clienteCodigo} - ${user.clienteRazonSocial} y quisiera registrar mi número de teléfono para las notificaciones automáticas.`
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary font-weight-semibold"
                      >
                        +54 9 358 5754880
                      </a>
                      .
                    </p>
                    <Button
                      onClick={() => {
                        const message = `Buenos días, soy el cliente ${user.clienteCodigo} - ${user.clienteRazonSocial} y quisiera registrar mi número de teléfono para las notificaciones automáticas.`;
                        const url = `https://wa.me/5493585754880?text=${encodeURIComponent(
                          message
                        )}`;
                        window.open(url, "_blank");
                      }}
                      className="btn btn-success"
                    >
                      Registrar Whatsapp
                    </Button>
                  </div>
                </div>
                <div className="col-2 d-flex align-items-center justify-content-center">
                  <div className="circle-icon bg-warning-transparent text-center">
                    <i className="fe fe-alert-circle tx-18 text-warning"></i>
                  </div>
                </div>
              </Row>
            </Card>
          </Col>
        )}
      </Row>

      <Row>
        <Col dm={12} lg={12} xl={3}>
          <RecibosVendedores />
        </Col>
        <Col lg={12} xl={3}>
          <PedidosRecibos />
        </Col>
        <Col lg={12} xl={3}>
          <Contrarreembolso />
        </Col>
        <Col lg={12} xl={3}>
          <RecibosEmpresa />
        </Col>
      </Row>
    </div>
  );
};

export default MisRecibos;
